import React from 'react'
import PropTypes from 'prop-types'
import { Message } from '@paypalcorp/worldready-react'
import { LoadingSpinner, BodyText } from '@paypalcorp/pp-react'

import { ModalHeader, ModalContent } from 'components/modal'
import CardImage from 'components/card/CardImage'
import CardBrandImage from 'components/card/CardBrandImage'

import { serverData } from 'utils/server-data'
import { formatPartialCardNumber } from 'utils/formatter'

import { modalHeaderCss, modalContentCss } from './style'

function LoadingSpinnerWithCardImage({
  card,
  showCardBrandImage = false,
  showCardBrandTitle = false,
  showCardSuffix = false,
  loading,
  cssProp,
  cardImageCssProp,
  brandTitleCssProp,
  brandTitleContentKey,
  modalheaderContent,
  showCardArtWithChip = false,
}) {
  if (!card) {
    return null
  }

  const { metadata, cardAttributes, cardNumberSuffix, additionalDetails } = card || {}
  const { shortProductName: cardName, imageUrls } =
    metadata || cardAttributes?.displayAttributes || {}
  const { cardFrontMedium = '', physicalCardOrderProgressCardArt = '' } = imageUrls || {}
  const cardImageUrl =
    showCardArtWithChip && physicalCardOrderProgressCardArt
      ? physicalCardOrderProgressCardArt
      : cardFrontMedium

  const shouldShowCardBrandTitle = !serverData.isMobileNative && showCardBrandTitle

  return (
    <>
      <div css={cssProp}>
        {cardImageUrl && (
          <CardImage
            cardNumberSuffix={showCardSuffix ? formatPartialCardNumber(cardNumberSuffix, 2) : ''}
            cssProp={cardImageCssProp}
            src={cardImageUrl}
            alt={cardName}
            loading={loading}
          />
        )}

        {showCardBrandImage && <CardBrandImage brandName={additionalDetails?.scheme} />}

        {shouldShowCardBrandTitle && (
          <BodyText css={brandTitleCssProp}>
            <Message id={brandTitleContentKey} cardName={cardName} />
          </BodyText>
        )}
      </div>

      {modalheaderContent && (
        <ModalHeader size="sm" align="center" css={modalHeaderCss}>
          {modalheaderContent}
        </ModalHeader>
      )}
      <ModalContent css={modalContentCss}>
        <LoadingSpinner screenReaderText={<Message id="common.loading" />} size="lg" />
      </ModalContent>
    </>
  )
}

LoadingSpinnerWithCardImage.propTypes = {
  card: PropTypes.object.isRequired,
  showCardBrandImage: PropTypes.bool,
  showCardBrandTitle: PropTypes.bool,
  showCardSuffix: PropTypes.bool,
  loading: PropTypes.bool,
  cssProp: PropTypes.object,
  cardImageCssProp: PropTypes.object,
  brandTitleCssProp: PropTypes.object,
  brandTitleContentKey: PropTypes.string,
  modalheaderContent: PropTypes.node,
  showCardArtWithChip: PropTypes.bool,
}

export default LoadingSpinnerWithCardImage
